<template>
<div class="chapter">
<div class="inner_page">
<h1 class="head1">To Look and Pass</h1>
<p class="head2">A Novel</p>
<p class="head3">Taylor Caldwell</p>
<div class="img_container1">
<img alt="image" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?e2c1c9d8